import React, { FC, useContext, useState } from 'react'
import {
  DownloadSection,
  HomeHeader,
  PersonalKnowledgeBase,
  WriteProtected,
  WhoIsStandardNotes,
} from '../components/home'
import { RemoteDownloadData, TPlatformPartialItem } from '../typings/download'
import MetaTags from '../components/meta_tags/meta_tags'
import { handleDownload } from '../utils/handleDownload'
import { getDownloadData } from '../utils/getDownloadData'
import AppDownloadsDataContext from '../context/appDownloadsDataContext'
import { getPlatformsIdToDataMapper } from '../utils/getPlatformsIdToDataMapper'
import ProtectYourself from '../components/home/protectYourself'

interface IProps {
  pageContext: {
    downloads: RemoteDownloadData
  }
}

const HomePage: FC<IProps> = ({ pageContext: { downloads } }) => {
  const { list, updateAppDownloadsData } = useContext(AppDownloadsDataContext)

  const latestFlattenedDownloads = list.length > 0 ? list : downloads.list

  const platformsIdToDataMapper = getPlatformsIdToDataMapper()
  const platformItems = getDownloadData({
    downloads: latestFlattenedDownloads,
    platformsIdToDataMapper,
  })
  const [currentPlatformItemIndex, setCurrentPlatformItemIndex] = useState<number | undefined>()

  const handlePlatformItemChange = (newPlatformItemIndex: number) => {
    setCurrentPlatformItemIndex(newPlatformItemIndex)
    updateAppDownloadsData({
      currentPlatformItemIndex: newPlatformItemIndex,
      platformItem: platformItems[newPlatformItemIndex] as TPlatformPartialItem,
    })
  }

  return (
    <section id="home-page">
      <HomeHeader platformItems={platformItems} handleDownload={handleDownload} />
      <PersonalKnowledgeBase />
      <WriteProtected />
      <ProtectYourself />
      <DownloadSection
        currentPlatformItemIndex={currentPlatformItemIndex}
        platformItems={platformItems}
        handleDownload={handleDownload}
        handlePlatformItemChange={handlePlatformItemChange}
      />
      <WhoIsStandardNotes />
    </section>
  )
}

export default HomePage

export const Head = () => {
  return (
    <MetaTags
      title="Standard Notes | End-To-End Encrypted Notes App"
      description="Standard Notes helps you gain control in a world that often feels out of control. Protect your life's work with end-to-end encryption, advanced security measures, and unmatched privacy controls."
      canonical={{ relative: '' }}
    />
  )
}
